// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3t3vd","inner":"Footer_inner__3hWjy","nextIcon":"Footer_nextIcon__2nioX","innerLeft":"Footer_innerLeft__2QXcU"};